import { FileText, Sparkles, BellRing, Route, Laugh, ListChecks, PieChart, MessageSquareText } from "lucide-react";
import { Reveal, SectionHeading } from "./shared";

const FEATURES = [
  { icon: FileText, title: "AI Clinical Notes", copy: "Visit notes drafted and structured before you sit down." },
  { icon: Sparkles, title: "AI Patient Summary", copy: "The whole treatment story, distilled into one glance." },
  { icon: BellRing, title: "AI Smart Reminders", copy: "Right nudge, right channel, right moment — automatically." },
  { icon: Route, title: "Treatment Timeline", copy: "A living map of every patient's orthodontic journey." },
  { icon: Laugh, title: "Smile Coach", copy: "Gamified motivation that keeps patients on track." },
  { icon: ListChecks, title: "Workflow Prioritization", copy: "Your day, reordered by what matters clinically." },
  { icon: PieChart, title: "Analytics Dashboard", copy: "Efficiency, utilization and growth — beautifully clear." },
  { icon: MessageSquareText, title: "Patient Communication", copy: "Every conversation, organized and AI-assisted." },
];

export default function FeatureHighlights() {
  return (
    <section id="resources" data-testid="features-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <SectionHeading
          testId="features-heading"
          eyebrow="Feature highlights"
          title="Small features. Massive leverage."
          sub="Every capability is designed to disappear into your workflow — until you notice the hours coming back."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-16">
          {FEATURES.map((feature, i) => (
            <Reveal key={feature.title} delay={(i % 4) * 0.08}>
              <div
                data-testid={`feature-card-${feature.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group h-full rounded-2xl border border-slate-200/80 bg-white p-6 transition-[box-shadow,transform,border-color,background-color] duration-400 hover:-translate-y-1.5 hover:shadow-[0_20px_44px_-12px_rgba(37,99,235,0.16)] hover:border-[#2563EB]/25"
              >
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#2563EB]/10 to-[#6366F1]/10 flex items-center justify-center transition-transform duration-400 group-hover:scale-110">
                  <feature.icon className="w-5 h-5 text-[#2563EB]" strokeWidth={1.8} />
                </div>
                <h3 className="font-display font-medium text-base tracking-tight text-[#0F172A] mt-4">
                  {feature.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed mt-1.5">{feature.copy}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
